<!-- TEMPLATE -->
<template>
  <div :class='usersListClass'>
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>{{title}}</span>
            </span>
          <dean-section-title-item v-if="!showArchive"
                                   :icon='archiveIcon'
                                   :content="true"
                                   @click.native="sectionRoute('profile.users.status', {status: 'verwijderd'})"
          >
            archief
          </dean-section-title-item>
          <dean-section-title-item v-else
                                   :icon='returnIcon'
                                   :content="true"
                                   @click.native="sectionRoute('profile.users')"
          >
            Terug naar actief
          </dean-section-title-item>
          <dean-section-title-item
                  v-if="authUserHasPrivilegeAndAction(UserPrivilege.USER, UserAction.CREATE)"
                  :icon='plusIcon'
                  :content="true"
                  @click.native="sectionRoute('profile.user.add')"
          >
            Nieuw
          </dean-section-title-item>
        </dean-section-title>
        <dean-table
                :data='usersData'
                :columns='columns'
                :hover="authUserHasPrivilegeAndAction(UserPrivilege.USER, UserAction.UPDATE)"
                @column-click='columnClick'
                @cell-click="cellClick"
        >
        </dean-table>
        <dean-pagination
                :current-page='usersMetaData.pageNumber'
                :total-items='usersMetaData.totalResults'
                :items-per-page='usersMetaData.itemsPerPage'
                :select-items-per-page='selectItemsPerPage'
                :visible-pages='usersMetaData.visiblePages'
                @page-changed='paginationChanged'
                @items-per-page='itemsPerPageChanged'
        >
        </dean-pagination>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuProfileMixin from '@/mixins/sideMenuProfileMixin';
  import {mixins} from 'vue-class-component';

  import {
    // SVG
    invoicesIcon,
    archiveIcon,
    returnIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
  } from '@deanone/dean-components';
  import {authUserHasPrivilegeAndAction} from "@/mixins/privileges";
  import {UserPrivilege} from "@/enums/UserPrivilege";
  import {UserAction} from "@/enums/UserAction";

  @Component({
    computed: {
      UserAction() {
        return UserAction
      },
      UserPrivilege() {
        return UserPrivilege
      }
    },
    methods: {authUserHasPrivilegeAndAction},
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuProfileMixin) {
    public url: string = '/-/trade/api/person.contact.list';
    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public archiveIcon: object = archiveIcon;
    public returnIcon: object = returnIcon;
    public data: object[] = [];
    public showArchive: boolean = false;
    public queryTimeout!: number;

    // COMPUTED
    get usersListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get usersMetaData() {
      return this.pageMeta;
    }

    get usersData() {
      return this.data;
    }

    get title() {
      return this.showArchive ? 'Verwijderde gebruikers' : 'Gebruikers';
    }

    public columns: any = {
      name: {
        content: 'Naam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      emailAddress: {
        content: 'E-mailadres',
        align: 'left',
        sort: true,
        dql: 'emailAddress',
      },
      receivesInvoices: {
        content: 'ontvangt facturen',
        align: 'left',
        sort: true,
        dql: 'invoices',
      },
      receivesNotifications: {
        content: 'ontvangt berichten',
        align: 'left',
        sort: true,
        dql: 'notifications',
      },
      roles: {
        content: 'Rollen',
        align: 'left',
        sort: false,
      },
    };

    public tableName(): string {
      return 'profile-users';
    }

    public cellClick(target: { cell: object, row: { id: string }, column: string }) {
      if (authUserHasPrivilegeAndAction(UserPrivilege.USER, UserAction.UPDATE)) {
        this.$router.push({
          name: 'profile.user.edit',
          params: {id: target.row.id},
        });
      }
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);
      let userRoles = '';

      const params = {
        id: this.$store.getters.getUser.organizationId,
        meta: {
          startIndex: this.startIndex,
          numberOfItems: data.itemsPerPage,
        },
        filter: data.query,
        deleted: this.showArchive ? true : undefined,
        sort: data.sort,
        isUser: true,
      };

      axios.post(this.url, params)
        .then(
          (usersResponse: any) => {
            this.data = usersResponse.data.data.map((user: any) => {
              userRoles = '';
              user.roles.forEach((role: any, index: any) => {
                if (index === user.roles.length - 1) {
                  userRoles += role.label;
                } else {
                  userRoles += role.label + ', ';
                }
              });
              return {
                id: user.id,
                name: user.name,
                emailAddress: user.emailAddress,
                receivesInvoices: user.receivesInvoices ? 'Ja' : 'Nee',
                receivesNotifications: user.receivesNotifications ? 'Ja' : 'Nee',
                roles: userRoles,
              };
            });

            this.updateMeta(usersResponse.data.meta);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public update(timeout: boolean) {
      this.pageMeta.pageNumber = 1;

      const self = this;
      const meta: any = self.pageMeta;

      if (timeout) {
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
        this.queryTimeout = setTimeout(() => {
          self.loadList(meta);
        }, 500);
      } else {
        this.loadList(meta);
      }
    }

    public created() {
      this.showArchive = this.$router.currentRoute.params.status === 'verwijderd';
      this.keepMetaSavedInState();
      this.setDefaultSort('name');
      this.loadList(this.pageMeta);
      this.buildSideMenuProfile();
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>
